import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InquiryService } from '../../../services/inquiry.service';
import { MaterialModule } from '../../../material.module';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { FileUtilsService } from '../../../services/file-utils.service';

@Component({
  selector: 'app-inquiry-create',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule
  ],
  templateUrl: './inquiry-create.component.html',
  styleUrls: ['./inquiry-create.component.scss']
})
export class InquiryCreateComponent {
  form!: FormGroup;
  selectedFiles: File[] = [];

  constructor(
    private fb: FormBuilder,
    private service: InquiryService,
    private snackBar: ModalSnackbarService,
    private fileUtils: FileUtilsService
  ) {
    this.form = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(100)]],
      acc: ['', Validators.maxLength(50)],
      body: ['', [Validators.required, Validators.maxLength(1000)]],
      files: [[], this.fileUtils.fileSizeValidator(20 * 1024 * 1024)] // 20MB
    });
  }

  onDragOver(event: DragEvent): void {
    this.fileUtils.onDragOver(event);
  }

  onDrop(event: DragEvent): void {
    const newFiles = this.fileUtils.extractValidDroppedFiles(event, this.selectedFiles);
    if (!newFiles) {
      this.snackBar.show(`ファイルは最大 ${this.fileUtils.MAX_FILE_COUNT} 個までです`);
      return;
    }

    this.fileUtils.addFiles(this.selectedFiles, newFiles, files => {
      this.updateSelectedFiles(files);
    });
  }

  onFileChange(event: Event): void {
    const newFiles = this.fileUtils.extractValidSelectedFiles(event, this.selectedFiles);
    if (!newFiles) {
      this.snackBar.show(`ファイルは最大 ${this.fileUtils.MAX_FILE_COUNT} 個までです`);
      return;
    }

    this.fileUtils.addFiles(this.selectedFiles, newFiles, updated => {
      this.updateSelectedFiles(updated);
      const input = event.target as HTMLInputElement;
      if (input.files) {
        input.value = ''; // 同じファイルでも選び直し可能にする
      }
    });
  }

  removeFile(index: number): void {
    this.fileUtils.removeFile(this.selectedFiles, index, updated => {
      this.updateSelectedFiles(updated);
    });
  }

  private updateSelectedFiles(files: File[]) {
    this.selectedFiles = files;
    this.form.get('files')?.setValue(files);
    this.form.get('files')?.updateValueAndValidity();
  }

  submit() {
    if (this.form.invalid) return;

    const formData = new FormData();

    const accText = (this.form.value.acc?.length > 0) ? `お問い合わせの口座番号 : ${this.form.value.acc}\n\n` : '';

    formData.append('category', 'お問い合わせ');
    formData.append('title', this.form.value.title);
    formData.append('child[body]', accText + this.form.value.body);

    this.form.value.files.forEach((file: File, i: number) => {
      formData.append(`attachments[]`, file, file.name);
    });

    this.service.uploadWithFile(formData).subscribe({
      next: () => {
        this.snackBar.show('問い合わせを作成しました', '/inquiry');
      },
      error: () => {
        this.snackBar.show('作成に失敗しました');
      }
    });
  }
}
